export default "__VITE_ASSET__DoEi2giB__"